module.exports = __webpack_public_path__ + "static/media/girl.9e379c2b.svg";